import React from "react";
import { View, StyleSheet, ViewStyle, TextStyle } from "react-native";

import Text from "../../Text";
import Rate from "../../Rate";
import { Row, Col } from "../../Grid";

type IProps = {
  matches?: boolean;
  label: string;
  rate: number;
};

type IState = {};

class PriciseRate extends React.PureComponent<IProps, IState> {
  public static defaultProps: Partial<IProps>;

  private getStyles(): StyleSheet.NamedStyles<{
    label: TextStyle;
    left: ViewStyle;
    right: ViewStyle;
    center: ViewStyle;
  }> {
    return StyleSheet.create({
      label: {
        fontSize: "0.875em" as any,
        textAlign: "center",
      },
      left: {
        alignItems: "flex-start",
      },
      right: {
        alignItems: "flex-end",
      },
      center: {
        alignItems: "center",
      },
    });
  }

  public render(): JSX.Element {
    const { rate, label, matches } = this.props;

    const styles = this.getStyles();

    if (!matches) {
      return (
        <Row breakpointList={{ all: Infinity }} col={{ all: 2 }}>
          <Col>
            <View style={styles.left}>
              <Text style={styles.label}>{label}</Text>
            </View>
          </Col>

          <Col>
            <View style={styles.right}>
              <Rate rate={rate} />
            </View>
          </Col>
        </Row>
      );
    }

    return (
      <Row breakpointList={{ all: Infinity }} col={{ all: 1 }}>
        <Col>
          <Text style={styles.label}>{label}</Text>
        </Col>

        <Col>
          <View style={styles.center}>
            <Rate rate={rate} />
          </View>
        </Col>
      </Row>
    );
  }
}

export default PriciseRate;
